import { FileCheck2, Lock, LockOpen } from 'lucide-react'
import Card from '../../../../components/common/Card'
import DefaultTabs from '../../../../components/common/Tabs'
import { useProfessional } from '../../../../context/ProfessionalContext'
import Notes from './Notes'

export function ProfessionalTabs() {
    const { detail, professionals } = useProfessional()
    if (!detail) return null

    //* Contadores
    const numNotesOpen = detail.notes.filter(note => note.status === 0).length
    const numNotesClosed = detail.notes.filter(note => note.status === 1).length
    const numAttachments = 0 //detail.attachments.length

    const tabsData = [
        {
            icon: <LockOpen className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Notas abertas</p>
                    {numNotesOpen > 0 && <p className='text-xs text-brand-400 font-bold'>{numNotesOpen}</p>}
                </div>
            ),
            value: 'tab1',
            content: <Notes title='Notas abertas' status={0} />
        },
        {
            icon: <Lock className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Notas fechadas</p>
                    {numNotesClosed > 0 && <p className='text-xs text-brand-400 font-bold'>{numNotesClosed}</p>}
                </div>
            ),
            value: 'tab2',
            content: <Notes title='Notas fechadas' status={1} />
        },
        {
            icon: <FileCheck2 className='w-4 h-4' />,
            label: (
                <div className='flex items-start justify-center gap-1'>
                    <p>Documentos</p>
                    {numAttachments > 0 && <p className='text-xs text-brand-400 font-bold'>{numAttachments}</p>}
                </div>
            ),
            value: 'tab3',
            content: (
                <Card>
                    <h2 className='font-bold text-base mb-4'>Documentos do profissional</h2>
                    <p>Em desenvolvimento...</p>
                </Card>
            )
        }
    ]

    return <DefaultTabs tabs={tabsData} defaultValue='tab1' />
}
